import React, {Component} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import {Container} from 'reactstrap';
import ReactGA from 'react-ga';

import {
    AppAside,
    AppBreadcrumb,
    AppFooter,
    AppHeader,
    AppSidebar,
    AppSidebarFooter,
    AppSidebarForm,
    AppSidebarHeader,
    AppSidebarMinimizer,
    AppSidebarNav,
} from '@coreui/react';
// sidebar nav config
import navigation from '../../_nav';
import _ from 'lodash';
// routes config
import routes from '../../routes';
import DefaultAside from './DefaultAside';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import {connect} from "react-redux";


import {
    AGENT_INFO_GET,
    AGENT_INFO_ROUTE
} from "../../actions/types";


import {getAjaxData} from "../../actions/IndexActions";

const callables = {
    getAjaxData,
};

class DefaultLayout extends Component {

    constructor(props) {
        super(props);

        this.state = {
            advertiserCommissionReportNavData: {
                name: 'Advertiser Commission Report',
                url: '/reports/advertiser-commission-report',
                icon: 'fa fa-bar-chart',
            },
            publisherCommissionReportNavData: {
                name: 'Publisher Commission Report',
                url: '/reports/publisher-commission-report',
                icon: 'fa fa-bar-chart',
            }
        }
    }

    componentDidMount() {
        ReactGA.initialize('UA-82328764-1');
        this.props.getAjaxData(AGENT_INFO_ROUTE, AGENT_INFO_GET, {})
    }

    getQueryVariable(variable)
    {
        let query = window.location.search.substring(1);
        let vars = query.split("&");
        for (let i=0;i<vars.length;i++) {
            let pair = vars[i].split("=");
            if(pair[0] === variable){return pair[1];}
        }
        return false;
    }

    render() {

        let navigateTo = this.getQueryVariable('i')
        if(navigateTo !== false) {
            return <Redirect to={navigateTo} push={true}/>
        }

        ReactGA.pageview(this.props.location.pathname + this.props.location.search);

        const routeInfo = _.find(routes, item => item.path === this.props.location.pathname);

        if (routeInfo !== undefined && routeInfo.hasOwnProperty('name')) {
            document.title = routeInfo.name + ' - Mobupps';
        } else {
            document.title = 'Mobupps';
        }

        const navIndexForReports = _.findIndex(navigation['items'], {name: "Reports"})
        navigation['items'][navIndexForReports]['children'] = [];
        if(this.props.agentInfo.hasOwnProperty('advertiserCommissionReportEnabled') && this.props.agentInfo['advertiserCommissionReportEnabled']) {
            navigation['items'][navIndexForReports]['children'].push(this.state.advertiserCommissionReportNavData);
        }
        if(this.props.agentInfo.hasOwnProperty('publisherCommissionReportEnabled') && this.props.agentInfo['publisherCommissionReportEnabled']) {
            navigation['items'][navIndexForReports]['children'].push(this.state.publisherCommissionReportNavData);
        }

        return (
            <div className="app">
                <AppHeader fixed>
                    <DefaultHeader/>
                </AppHeader>
                <div className="app-body">
                    <AppSidebar fixed display="lg">
                        <AppSidebarHeader/>
                        <AppSidebarForm/>
                        <AppSidebarNav navConfig={navigation} {...this.props} />
                        <AppSidebarFooter/>
                        <AppSidebarMinimizer/>
                    </AppSidebar>
                    <main className="main">
                        <AppBreadcrumb appRoutes={routes}/>
                        <Container fluid>
                            <Switch>
                                {routes
                                    .map((route, idx) => {
                                            return route.component ? (
                                                    <Route key={idx} path={route.path} exact={route.exact} name={route.name}
                                                           render={props => (
                                                               <route.component {...props} />
                                                           )}/>)
                                                : (null);
                                        },
                                    )}
                                <Redirect from="/" to="/dashboard"/>
                            </Switch>
                        </Container>
                    </main>

                </div>
                <AppFooter>
                    <DefaultFooter/>
                </AppFooter>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    agentInfo: state.agent.agentInfo,
})

export default connect(mapStateToProps, callables)(DefaultLayout);